import htmlIcon from "../img/Icons/Logos/HTML5Logo.png";

export default function HTMLSkill(){
    return (
        <div className="skillTile">
            <img src={htmlIcon} alt="csharp"/>
            <div className="skillTexts">
                <h2>HTML</h2>
            </div>
        </div>
    )
}